export const REGEX = {
  emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  mobileReg: /^(\+\d{1,3}[-]?)?\d{10}$/,
  passReg:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/,
  nameReg: /^[a-zA-Z0-9-]+$/,
  nameRegWithSpace: /^[a-zA-Z0-9 -]+$/,
};
